/*
 * debug 1.0.0
 * Licensed under: MIT
 */
import util from './util.js'

class Debug {
  constructor(){
    // 是否初始化，是否收起
    this.isInit = this.isHide = false;

    // 当前消息，当前执行函数，当前颜色
    this.msg = this.fn = this.color = '';

    // 外层元素
    this.el = null;

    // debug 容器底部预留的高度
    this.parentRight = 6;

    //最长条数设置
    this.maxLength = 10;

    //是否显示事件
    this.time = true;

    //关闭
    this.close = false;

    //隐藏事件计数
    this.eventTime = null;
    this.eventNum = 0;
    this.eventKey = 38;

    //检查debugModel
    //this.isDebugModel();

    //监听系统错误
    this.bindErr();

    //用户缩放倍数
    this.userScale = 1;
  }
  init(){
    //填充容器
    let el = this.el = document.createElement('div');
    el.setAttribute('style', this.joinCss(this.parentCss()));

    let screenW = window.outerWidth || window.screen.width;

    el.innerHTML = `
      <div id='debug-list' style='max-height:6em;overflow:auto'></div>
      <div style='${this.childCss().join(';')};font-size:${241/screenW}em''>
      <div id='debug-info-fps' style='float:left;width:28%;font-size:1.2em;text-align:center;padding-top:4%;'></div>
      <div style='float:left;width:72%;font-size:0.7em;box-sizing:border-box;border-left: 1px solid rgba(255,255,255,.1);padding-left: 5%;line-height: 1.7em;
}'>${navigator.userAgent.toLowerCase()}</div>
      <div style='clear:both'></div>
      </div>
    `

    let body = util.getBody();
    body.appendChild(el);

    util.showFps()

    // 初始位置
    this.translate(el, 0)

    // 绑定事件
    util.bind(el, 'click',() => {
      this.toggle();
    })

    //隐藏事件
    this.hideEvent()

    this.isInit = true;

    return this;
  }
  // 将不同类型的msg转换为可读的String
  render(msg, index = 0){
    let text = ''
    let arr = []
    let deepin = 4  //递归解析最大设置

    if(util.isArray(msg)){
      if(JSON || JSON.stringify || index === 0){
        try{
          text = JSON.stringify(msg);
        }catch(e){
          if(index >= deepin) return '{···}'
          for (let i = 0, len = msg.length; i < len; i++) {
            let item = msg[i];
            if (typeof(item) === 'object') {
              arr.push(this.render(item, index++));
              text = '[' + arr.join(',') + ']';
            } else {
              arr.push(item);
              text = '[' + arr.join(',') + ']';
            }
          }
        }
      }else{
        if(index >= deepin) return '{···}'
        for (let i = 0, len = msg.length; i < len; i++) {
          let item = msg[i];
          if (typeof(item) === 'object') {
            arr.push(this.render(item, index++));
            text = '[' + arr.join(',') + ']';
          } else {
            arr.push(item);
            text = '[' + arr.join(',') + ']';
          }
        }
      }
    }else if(util.isObject(msg)){
      if(util.isDomObject(msg)){
        text = '[object HTMLBodyElement]';
        return text;
      }
      if(JSON || JSON.stringify || index === 0){
        try{
          text = JSON.stringify(msg);
        }catch(e){
          if(index >= deepin) return '[···]'
          for (let item in msg) {
            if (typeof(msg[item]) === 'object') {
              arr.push(item+': ' + this.render(msg[item], index++));
              text = '{' + arr.join(',') + '}';
            } else {
              arr.push(item+': '+msg[item]);
              text = '{' + arr.join(',') + '}';
            }
          }
        }
      }else{
        if(index >= deepin) return '[···]'
        for (let item in msg) {
          if (typeof(msg[item]) === 'object') {
            arr.push(item+': ' + this.render(msg[item], index++));
            text = '{' + arr.join(',') + '}';
          } else {
            arr.push(item+': '+msg[item]);
            text = '{' + arr.join(',') + '}';
          }
        }
      }
    }else{
      text = String(msg)
    }
    return text;
  }
  hideEvent(){
    util.bind(window, 'keyup', e => {
      if(e.keyCode === this.eventKey){
        if(this.eventNum < 2){
          this.eventNum += 1;
          this.eventTime = setTimeout(()=>{
            this.eventNum = 0;
          }, 500)
        }else{
          this.eventNum = 0;
          this.toggle()
        }
      }
    })
  }
  // 设置translate
  translate(el, x){
    el.style.webkitTransform = 'translate3d('+x+',0,0)';
    el.style.transform = 'translate3d('+x+',0,0)';
  }

  joinCss(css){
    return css.join(';');
  }

  publicCss(){
    return [
      '-webkit-transition: all .3s ease',
      'transition: all .3s ease'
    ];
  }

  // 每个debug信息样式
  childCss(){
    let screenW = window.outerWidth || window.screen.width;
    return [
      'margin-top:-1px',
      'padding:10px',
      'border-top:1px solid rgba(255,255,255,.1)',
      'margin:0',
      'font-size:'+(221/screenW)+'em'
    ].concat(this.publicCss());
  }

  // debug容器的样式
  parentCss(){
    let screenW = window.outerWidth || window.screen.width;
    return [
      '-webkit-overflow-scrolling:touch',
      'overflow:auto',
      'z-index:99999999',
      'position:fixed',
      'left:'+(100/screenW * 1.5)+'em',
      'bottom:'+(100/screenW * 1.5)+'em',
      'background:rgba(0,0,0,.8)',
      'color:#fff',
      'font-size:'+(screenW/10 * this.userScale)+'px',
      'line-height:'+(281/screenW * 1.5)+'em',
      'width:35%',
      'padding-right:'+this.parentRight+'px',
      'border-radius:10px;'
    ].concat(this.publicCss());
  }
  //过滤HTML
  filterHtmlString(html){
    html = html.replace(/</g,'&lt;');
    html = html.replace(/>/g,'&gt;');
    return html;
  }
  // `debug.print()`
  // 核心的输出debug信息方法
  print(){
    if(!this.isInit) this.init();

    let css = this.childCss().concat(['color:#'+this.color])
    let child = document.createElement('p')
    let time = new Date();
    time = `<span style="color:#fff;font-size:0.80em">${time.getHours()}:${time.getMinutes()}:${time.getSeconds()} >> </span>`
    child.setAttribute('style', this.joinCss(css))
    child.innerHTML = (this.time ? time : '') + this.filterHtmlString(this.msg);

    let sv = this.el.querySelector('#debug-list');
    let length = sv.children.length;
    if(this.maxLength === -1 || length < this.maxLength){
      sv.appendChild(child);
    }else{
      //删除顶部一个
      sv.removeChild(sv.children[0]);
      sv.appendChild(child);
    }
    let dl = document.querySelector('#debug-list');
    dl.scrollTop = dl.scrollHeight;
    return this;
  }
  // `debug.toggle()`
  // 隐藏和收起
  toggle(event){
    (this.isHide === true ? this.show : this.hide).call(this, event);
  }
  show(event){
    if(!this.isHide) return false;
    this.translate(this.el, '0px');
    this.isHide = false;

    return this;
  }
  hide(event){
    if(this.isHide) return false;
    this.translate(this.el, '-'+(this.el.offsetWidth - this.parentRight)+'px');
    this.isHide = true;

    return this;
  }
  listenerErr(err){
    if(typeof err === 'string'){
      // 只输出有用的错误信息
      let msg = [
        'Error:',
        ' - '+ err
      ]
      this.error(msg.join('\n'));
    }else{
      // 只输出有用的错误信息
      let msg = [
        'Error:',
        ' - filename: '+ err.filename,
        ' - lineno: '+ err.lineno,
        ' - message: '+ err.message,
        ' - type: '+ err.type
      ]
      this.error(msg.join('\n'));
    }
  }
  bindErr(){
    window.onerror = this.listenerErr.bind(this);
  }
  unbindErr(){
    window.onerror = null;
  }
  scale(n){
    //设置字体放大倍数
    this.userScale = n || 1;
    //重载样式
    this.el.setAttribute('style', this.joinCss(this.parentCss()));
  }
}

// 种类和颜色
const colorMap = {
  log: '0074cc',
  danger: 'f8d531',
  warn: 'faa732',
  success: '5bb75b',
  error: 'bd362f'
}
//初始化方法
for(let fn in colorMap){
  Debug.prototype[fn] = (function(fn) {
    return function(msg) {
      if(!this.close){
        this.fn = fn;
        this.msg = this.render(msg);
        this.color = colorMap[fn];
        return this.print();
      }else{
        console.info(msg)
      }
    };
  })(fn);
}


export default new Debug();



/** WEBPACK FOOTER **
 ** ./lib/debug.js
 **/